import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// Paginas visiveis: primeira, ultima e duas em volta da atual, com "…" nos saltos.
export function pageItems(page, pages) {
  const set = new Set([1, pages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= pages));
  const sorted = [...set].sort((a, b) => a - b);
  const items = [];
  sorted.forEach((p, index) => {
    if (index > 0 && p - sorted[index - 1] > 1) items.push(`gap-${p}`);
    items.push(p);
  });
  return items;
}

/** Paginacao numerada: no celular so Anterior/Proxima com "Pagina X de Y". */
export default function Pagination({ page, pages, onChange, disabled }) {
  if (pages <= 1) return null;
  return (
    <nav className='ad-pagination' aria-label='Paginação'>
      <button type='button' className='ad-page-btn ad-page-step' disabled={disabled || page <= 1} onClick={() => onChange(page - 1)}>
        <FontAwesomeIcon icon={faChevronLeft} aria-hidden='true' />
        <span>Anterior</span>
      </button>

      <ol className='ad-page-numbers'>
        {pageItems(page, pages).map((item) => (
          typeof item === 'string'
            ? <li key={item} className='ad-page-gap' aria-hidden='true'>…</li>
            : (
              <li key={item}>
                <button
                  type='button'
                  className={`ad-page-btn${item === page ? ' is-current' : ''}`}
                  aria-current={item === page ? 'page' : undefined}
                  aria-label={`Página ${item}`}
                  disabled={disabled}
                  onClick={() => item !== page && onChange(item)}
                >
                  {item}
                </button>
              </li>
            )
        ))}
      </ol>

      <span className='ad-page-mobile'>Página {page} de {pages}</span>

      <button type='button' className='ad-page-btn ad-page-step' disabled={disabled || page >= pages} onClick={() => onChange(page + 1)}>
        <span>Próxima</span>
        <FontAwesomeIcon icon={faChevronRight} aria-hidden='true' />
      </button>
    </nav>
  );
}
